<template lang='pug'>
  v-progress-linear.bionic-loading-bar(v-if='requestCount' :indeterminate='true' color='success')
</template>

<script>
import axios from 'axios';

export default {
  name: 'BionicMetricsLoadingBar',
  components: {},
  mounted() {
    axios.interceptors.request.use((config) => {
      this.requestCount++;
      return config;
    }, (error) => Promise.reject(error));

    axios.interceptors.response.use((response) => {
      this.requestCount--;
      return response;
    }, (error) => {
      this.requestCount--;
      return Promise.reject(error);
    });
  },
  data() {
    return {requestCount: 0};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bionic-loading-bar {
    z-index: 110;
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    max-height: 4px;
    width: 100%;
  }
</style>
